import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'jobs',
  inputShow: gql`
    query jobs($input: JobQueryInput) {
      jobs(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    label: 'Jobs',
    group: 'root',
    order: 5,
  },
};
